/**
 * Accordions
 */
import $ from "jquery";

$(".js-accordion .accordion__head").on("click", function (e) {
	e.preventDefault();

	$(this)
		.parent()
		.toggleClass("is-active")
		.find(".accordion__body")
		.slideToggle()
		.end()
		.siblings()
		.removeClass("is-active")
		.find(".accordion__body")
		.slideUp()
		.end();
});

function handleAccordionMobileState() {
	if (window.innerWidth <= 768) {
		// Adjust breakpoint as needed
		$(".js-accordion .accordion__section").removeClass("is-active");
		$(".js-accordion .accordion__body").hide();
	}
}

// Run on page load
$(document).ready(function () {
	handleAccordionMobileState();
});

// Run on resize
$(window).on("resize", function () {
	handleAccordionMobileState();
});
